
import { supabase } from '@/integrations/supabase/client';

interface SendInvitationEmailParams {
  invitationId: string;
  token: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  storeId: string;
}

export const sendInvitationEmail = async (
  params: SendInvitationEmailParams
): Promise<{ 
  success: boolean; 
  emailSent?: boolean; 
  emailError?: string; 
  emailDetails?: string;
}> => {
  try {
    console.log("Sending invitation email directly to:", params.email);
    
    // Get store name for the email
    const { data: storeData, error: storeError } = await supabase
      .from("stores")
      .select("name")
      .eq("id", params.storeId)
      .single();

    if (storeError) {
      console.error("Error fetching store:", storeError);
      return { 
        success: false, 
        emailSent: false,
        emailError: "Failed to fetch store details" 
      };
    }

    // Call the Edge Function to handle email sending
    const { data, error } = await supabase.functions.invoke('send-staff-invitation', {
      body: {
        invitationId: params.invitationId,
        token: params.token,
        email: params.email,
        firstName: params.firstName,
        lastName: params.lastName,
        role: params.role,
        storeName: storeData.name
      }
    });
    
    if (error) {
      console.error("Error invoking send-staff-invitation function:", error);
      return { 
        success: false, 
        emailSent: false,
        emailError: error.message || "Error calling invitation function" 
      };
    }
    
    console.log("Email function response:", data);
    
    return { 
      success: data.success || false,
      emailSent: data.emailSent || false,
      emailError: data.emailError,
      emailDetails: data.emailDetails
    };
  } catch (error: any) {
    console.error("Error sending invitation email:", error);
    return { 
      success: false,
      emailSent: false,
      emailError: error.message || "Unknown error sending invitation email"
    };
  }
};
